import { voiceMedia } from '@/lib/voiceMedia';
import { getPreDeaf, getPreMute } from '@/lib/voicePrefs';

/**
 * The mic/sound state to walk into a channel with. Sent with `voice:join`
 * (the server applies it atomically with the join) and applied locally first,
 * so a pre-muted mic is never live for a moment — the stored toggles used to
 * be read by nothing, and every join started with an open mic. Used by the
 * first join and by the rejoin after a reconnect.
 */
export function initialVoiceSelfState(): { selfMute: boolean; selfDeaf: boolean } {
  const state = { selfMute: getPreMute(), selfDeaf: getPreDeaf() };
  voiceMedia.setMuted(state.selfMute);
  voiceMedia.setDeafened(state.selfDeaf);
  return state;
}
